import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Form, Checkbox } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ReactTable from 'Common/ReactTableWrapper';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { ItemListingReportEnum } from 'Common/FieldEnum';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

import * as ItemListingSelectors from '../state/selectors';

class ItemListContainer extends Component {
  static propTypes = {
    itemListingReportData: PropTypes.array.isRequired,
    onSortedChange: PropTypes.func,
    onFilteredChange: PropTypes.func,
    sorted: PropTypes.array,
    filtered: PropTypes.array,
    reactTableRef: PropTypes.object,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    onSortedChange: () => {},
    onFilteredChange: () => {},
    sorted: [],
    filtered: [],
    reactTableRef: null,
    loading: false,
  };

  columns = [
    {
      Header: currentRows => {
        const {
          input: { value },
        } = this.props;
        const dataObjs = currentRows.data;
        let filteredData = [];
        let checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[ItemListingReportEnum.Id]
            ? obj[ItemListingReportEnum.Id]
            : obj._original[ItemListingReportEnum.Id];
          if (value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={Boolean(
              dataObjs.length > 0 && checkAllIds.length === dataObjs.length
            )}
            onClick={(e, data) => {
              this.handleHeaderLevelCheckBox(
                filteredData,
                data.checked,
                dataObjs
              );
            }}
          />
        );
      },
      Cell: ({ original }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                this.props.input.value.indexOf(
                  original[ItemListingReportEnum.Id]
                ) !== -1
              }
              onClick={(e, data) => {
                this.handleChangeCheckbox(original, data.checked);
              }}
            />
          </div>
        );
      },
      accessor: ItemListingReportEnum.Id,
      ...ReactTableWrapperColumnProperties,
      filterable: false,
      sortable: false,
      maxWidth: 200,
    },
    {
      Header: 'Item Code',
      accessor: ItemListingReportEnum.ItemCode,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Item Description',
      accessor: ItemListingReportEnum.Description,
      ...ReactTableWrapperColumnProperties,
    },
  ];

  handleHeaderLevelCheckBox = (filteredData, checked, dataObjs) => {
    const {
      input: { value },
    } = this.props;
    if (checked) {
      this.props.input.onChange([...filteredData, ...value]);
    } else {
      const copySelected = [...filteredData, ...value];
      _.forEach(dataObjs, obj => {
        const id = obj[ItemListingReportEnum.Id]
          ? obj[ItemListingReportEnum.Id]
          : obj._original[ItemListingReportEnum.Id];
        const index = copySelected.indexOf(id);
        if (index !== -1) {
          copySelected.splice(index, 1);
        }
      });
      this.props.input.onChange(copySelected);
    }
  };

  handleChangeCheckbox = (original, checked) => {
    const { input } = this.props;
    const formValues =
      input.value && input.value.length ? [...input.value] : [];
    const index = formValues.indexOf(original[ItemListingReportEnum.Id]);
    if (checked && index === -1) {
      formValues.push(original[ItemListingReportEnum.Id]);
    } else if (index > -1) {
      formValues.splice(index, 1);
    }
    input.onChange(formValues);
  };
  render() {
    const {
      itemListingReportData,
      loading,
      onSortedChange,
      sorted,
      filtered,
      reactTableRef,
      onFilteredChange,
    } = this.props;

    return (
      <Form.Field>
        <ReactTable
          defaultPageSize={20}
          showPageSizeOptions={true}
          minRows={0}
          data={itemListingReportData}
          noDatatext={itemListingReportData ? '' : 'No rows found'}
          resizable={false}
          className={'-striped -highlight grid--fixed-row-height'}
          columns={this.columns}
          loading={loading}
          loadingText={loading ? 'Loading...' : ''}
          defaultFilterMethod={caseInsensitiveFilter}
          reactTableRef={reactTableRef}
          onFilteredChange={onFilteredChange}
          onSortedChange={onSortedChange}
          sorted={sorted}
          filtered={filtered}
          menu={false}
          saveState={{
            tableName: TableNamesEnum.ITEM_LISTING_REPORT_TABLE,
          }}
        />
      </Form.Field>
    );
  }
}

const mapStateToProps = state => {
  return {
    itemListingReportData: ItemListingSelectors.getItemListingReportData(state),
    loading: ItemListingSelectors.getLoading(state),
  };
};

export const ItemList = connect(
  mapStateToProps,
  null
)(ItemListContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/itemlistingreport/containers/ItemListContainer.js